<div vng-dialog-title class="text-center">Add To FlyCuts</div>
<vng-dialog-content>
  <form class="clearfix form" [formGroup]="form" (ngSubmit)="copyAllCategoryTemplateToShortcut(form.value)">
    <div>You are about to add all FlyPlates to FlyCuts. Pick a category to add.</div>
    <div class="top-gap">
      <!-- Shared app-category-select (same recipe as template-copy); creation
           stays here via shortcutCategoryRename. -->
      <app-category-select
        #categorySelect
        label="Category"
        style="width: 100%"
        [control]="form.controls['category_id']"
        [options]="categoryOptions"
        [error]="
          form.controls['category_id'].invalid &&
          (form.controls['category_id'].dirty || form.controls['category_id'].touched) &&
          form.controls['category_id'].hasError('required')
            ? 'You must select a category.'
            : ''
        "
        (createCategory)="shortcutCategoryRename($event ? { name: $event } : {})"
      ></app-category-select>
    </div>

    <div class="dialog-actions">
      <button style="flex: 1" type="button" vng-button variant="outline" tabindex="2" (click)="close()">Cancel</button>
      <button style="flex: 1" type="submit" vng-button variant="primary" tabindex="-1">Add All</button>
    </div>
  </form>
</vng-dialog-content>
